import React, { Fragment } from 'react';
import { filter } from 'lodash';
import { animateScroll } from 'react-scroll';
import Panel from '../../../../../components/outline/Panel';
import InputForm from '../../../../../components/form/InputForm';
import Button from '../../../../../components/Button';
import { REX_NAME, REX_INSTAGRAM_URL, REX_URL } from '../../../../../lib/rex';
import { asyncSimpleModal, getRandomNumber } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import Anchor from '../../../../../components/link/Anchor';
import './BrandDetailInfoSns.scss';

const BrandDetailInfoSns = (props) => {
  const { data, form, setData, isEditable } = props;

  return (
    <Panel className="brand-detail-info-sns">
      <div className="panel-header">
        <div className="title">SNS 정보</div>
      </div>

      <div className="panel-body">
        {data.map((item, index) => {
          return (
            <div className="sns-input-wrap" key={index}>
              {index < 3 ? (
                <InputForm
                  label={item.typeName}
                  form={form}
                  isEditable={isEditable}
                  rules={[
                    {
                      pattern: index === 0 ? REX_INSTAGRAM_URL : REX_URL,
                      message: '올바른 URL 을 입력하시기 바랍니다.',
                    },
                  ]}
                  initialValue={item.url}
                  alterForm={<Anchor text={item.url} color="primary" isUnderLine href={item.url} target="_blank" />}
                  onChange={(value) => {
                    setData({
                      path: ['brandDetail', 'info', 'snsInfoRows', index],
                      value: {
                        id: item.id,
                        typeName: item.typeName,
                        no: item.no,
                        url: value,
                      },
                    });
                  }}
                  name={`sns_${index}`}
                />
              ) : null}
              {index >= 3 ? (
                <Fragment key={`snsEtc_${index}`}>
                  <InputForm
                    className="sns-type-name"
                    form={form}
                    isEditable={isEditable}
                    rules={[
                      formRequiredRules(true, '필수사항 입니다.'),
                      { pattern: REX_NAME, message: 'sns 종류를 확인해주세요.' },
                    ]}
                    initialValue={item.typeName}
                    onChange={(value) =>
                      setData({
                        path: ['brandDetail', 'info', 'snsInfoRows', index],
                        value: {
                          id: item.id,
                          typeName: value.trim(),
                          no: item.no,
                          url: item.url,
                        },
                      })
                    }
                    name={`snsTypeName_${item.id}`}
                  />

                  <InputForm
                    className="sns-url"
                    form={form}
                    isEditable={isEditable}
                    rules={[
                      formRequiredRules(true, '필수사항 입니다.'),
                      { pattern: REX_URL, message: '올바른 URL 을 입력하시기 바랍니다.' },
                    ]}
                    initialValue={item.url}
                    alterForm={<Anchor text={item.url} color="primary" isUnderLine href={item.url} target="_blank" />}
                    onChange={(value) =>
                      setData({
                        path: ['brandDetail', 'info', 'snsInfoRows', index],
                        value: {
                          id: item.id,
                          typeName: item.typeName,
                          no: item.no,
                          url: value,
                        },
                      })
                    }
                    name={`snsUrl_${item.id}`}
                  />

                  {isEditable ? (
                    <Button
                      key={index}
                      isRadius
                      color="red"
                      text="SNS 삭제"
                      className="sns-delete-button"
                      onClick={() => {
                        setData({
                          path: ['brandDetail', 'info', 'snsInfoRows'],
                          value: filter(data, (item, _index) => _index !== index),
                        });
                      }}
                    />
                  ) : null}
                </Fragment>
              ) : null}
            </div>
          );
        })}

        {isEditable ? (
          <Button
            isRadius
            color="primary"
            text="SNS 추가"
            onClick={async () => {
              if (data.length >= 6) {
                await asyncSimpleModal({
                  type: 'confirm',
                  title: 'SNS 채널 추가',
                  message: '더 이상 SNS 를 추가할 수 없습니다',
                });
              } else {
                setData({
                  path: ['brandDetail', 'info', 'snsInfoRows', data.length],
                  value: {
                    id: getRandomNumber(),
                    no: null,
                    typeName: null,
                    url: null,
                  },
                });
                animateScroll.scrollToBottom(0);
              }
            }}
          />
        ) : null}
      </div>
    </Panel>
  );
};

export default BrandDetailInfoSns;
